module.exports = __webpack_public_path__ + "static/Ketch-940156b9bbd86f087abd7ca5ef5d435b.jpg";